export default "__VITE_ASSET__BBd1ca9l__"